import * as React from 'react';
import styled from 'styled-components';
import { LG } from '@origin-digital/helper';
import { AlertBox } from '@origin-digital/style-guide';

interface AlertProps {
  text: string;
}

const Alert: React.FC<AlertProps> = ({ text }) => (
  <AlertBoxContainer data-id="alert-box-container">
    <AlertBox type="warning" heading="" markdown={true} message={text} />
  </AlertBoxContainer>
);

export { Alert };

const AlertBoxContainer = styled.div`
  margin-bottom: 24px;
  ${LG`
    margin-bottom: 32px;
  `}
`;
